import type { Survey, SurveySession } from '../fetchSurvey/types/survey';

export const QUESTION_ACTIVITY_STATE = {
  VIEWED: 'VIEWED',
} as const;

export type QuestionActivityState = (typeof QUESTION_ACTIVITY_STATE)[keyof typeof QUESTION_ACTIVITY_STATE];

export type RecordQuestionActivityRequestBody = {
  questionIds: string[];
  state: QuestionActivityState;
  surveyId: string;
  responseId: string;
  instanceCreatedTime: number;
};

export type UseRecordQuestionActivityProps = {
  session?: SurveySession | null;
  survey?: Survey | null;
  getInstanceCreatedTime: () => number | undefined;
  onQuestionViewed?: (questionId: string, pageIndex?: number) => void;
};
